import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
const ClientSeminarOneConfirmHoc = () => (ChildComponent) => {
    const ClientSeminarOneConfirmHocInner = (props) => {
        const { state: locationState } = useLocation();
        const { seminar } = locationState || {};
        const values = useSelector((state) => state.finalForm.form.ClientSeminarOneRequestForm);
        // history.pushで値が渡されていなければリダイレクト
        if (!seminar) {
            return _jsx(CustomRedirect, { to: '/seminar' });
        }
        // フォームの入力値が存在しなければリダイレクト
        if (!values) {
            return _jsx(CustomRedirect, { to: `/seminar/${seminar.id}/request` });
        }
        return _jsx(ChildComponent, Object.assign({}, props, { seminar: seminar, values: values }));
    };
    ClientSeminarOneConfirmHocInner.propTypes = {
        match: propMatch(),
    };
    return ClientSeminarOneConfirmHocInner;
};
export default ClientSeminarOneConfirmHoc;
